import { Link } from "react-router-dom";
import { Scale, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Footer = () => {
  const { user } = useAuth();
  return (
  <footer className="border-t border-hairline bg-canvas mt-24" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <div className="grid md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo.png?v=2" alt="Justice Verse" className="jv-logo-img w-9 h-9 object-contain" />
            <span className="font-serif text-2xl tracking-[0.18em] text-ink">JUSTICE VERSE</span>
          </div>
          <p className="text-inkfaint text-sm leading-relaxed max-w-md">
            JusticeVerse is India&apos;s most advanced AI legal platform for advocates, judges, law students and
            firms — AI legal research, drafting, case briefs, document translation and judiciary exam prep.
          </p>
          <div className="mt-6" data-testid="footer-contact">
            <h4 className="font-mono text-[10px] uppercase tracking-[0.25em] text-inkfaint mb-3">Contact Us</h4>
            <p className="text-inkfaint text-sm">For help or any query, write to us at:</p>
            <a href="mailto:justice@justice-verse.com" data-testid="footer-contact-email"
               className="mt-2 inline-flex items-center gap-2 text-sm text-ink hover:text-gold transition-colors">
              <Mail className="w-4 h-4 text-gold" /> justice@justice-verse.com
            </a>
          </div>
        </div>
        <div>
          <h4 className="font-mono text-[10px] uppercase tracking-[0.25em] text-inkfaint mb-5">Modules</h4>
          <ul className="space-y-3 text-sm text-inkmuted">
            <li><Link to="/justicebot" className="hover:text-gold">JusticeVerse AI</Link></li>
            <li><Link to="/counsel" className="hover:text-gold">Counsel AI</Link></li>
            <li><Link to="/casebrief" className="hover:text-gold">CaseBrief AI</Link></li>
            <li><Link to="/verse-translation" className="hover:text-gold">Verse Translation</Link></li>
            <li><Link to="/prepmate" className="hover:text-gold">PrepMate AI</Link></li>
            <li><Link to="/knowledge-hub" className="hover:text-gold">Articles & Daily Digest</Link></li>
            <li><Link to="/careers" className="hover:text-gold">Careers</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-[10px] uppercase tracking-[0.25em] text-inkfaint mb-5">Solutions</h4>
          <ul className="space-y-3 text-sm text-inkmuted">
            <li><Link to="/ai-legal-research" className="hover:text-gold">AI Legal Research</Link></li>
            <li><Link to="/ai-legal-drafting" className="hover:text-gold">AI Legal Drafting</Link></li>
            <li><Link to="/ai-case-brief" className="hover:text-gold">AI Case Brief</Link></li>
            <li><Link to="/document-translation" className="hover:text-gold">Document Translation</Link></li>
            <li><Link to="/document-analysis" className="hover:text-gold">Document Analysis</Link></li>
            <li><Link to="/judiciary-preparation" className="hover:text-gold">Judiciary Preparation</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-[10px] uppercase tracking-[0.25em] text-inkfaint mb-5">Platform</h4>
          <ul className="space-y-3 text-sm text-inkmuted">
            <li><Link to="/pricing" className="hover:text-gold">Subscription</Link></li>
            <li><Link to="/justiceverse-ai" className="hover:text-gold">About JusticeVerse</Link></li>
            <li><Link to="/best-legal-ai-for-advocates" className="hover:text-gold">For Advocates</Link></li>
            <li><Link to="/best-legal-ai-for-law-students" className="hover:text-gold">For Law Students</Link></li>
            <li><a href="mailto:justice@justice-verse.com" className="hover:text-gold" data-testid="footer-platform-contact">Contact Us</a></li>
            {user ? (
              <li><Link to="/dashboard" className="hover:text-gold">My Workspace</Link></li>
            ) : (
              <>
                <li><Link to="/register" className="hover:text-gold">Create Account</Link></li>
                <li><Link to="/login" className="hover:text-gold">Sign In</Link></li>
              </>
            )}
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-hairline flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Scale className="w-5 h-5 text-inkfaint" />
          <span className="font-mono text-xs tracking-[0.15em] text-inkfaint">
            © 2026 JUSTICEVERSE GLOBAL SERVICES CO.
          </span>
        </div>
        <span className="font-mono text-xs tracking-[0.15em] text-inkfaint">
          <a href="mailto:justice@justice-verse.com" className="hover:text-gold" data-testid="footer-bottom-contact">JUSTICE@JUSTICE-VERSE.COM</a> &nbsp;|&nbsp; TERMS &amp; PRIVACY &nbsp;|&nbsp; ADVANCING LAW GLOBALLY
        </span>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
